export enum Ambassador {
  Lapenko = 'Lapenko',
  Kuruch = 'Kuruch',
  Academeg = 'Academeg',
  Ponaroshku = 'Ponaroshku',
  Chebatkov = 'Chebatkov',
  Slutskiy = 'Slutskiy',
  Krut = 'Krut',
}

export const ambassadorsWishes = {
  [Ambassador.Krut]: {
    title: 'Для вас пожелание от Крута',
    avatar: {
      src: {
        png: 'static/ny25/avatarKrut-184-2024-12-09-08-30-38.png 320w',
        avif: 'static/ny25/avatarKrut-184-2024-12-09-08-30-38.avif 854w',
        webp: 'static/ny25/avatarKrut-184-2024-12-09-08-30-38.webp 320w',
      },
      alt: 'фото',
    },
  },
  [Ambassador.Slutskiy]: {
    title: 'Для вас пожелание от Леонида Слуцкого',
    avatar: {
      src: {
        png: 'static/ny25/avatarSlutskiy-184-2024-12-09-08-22-25.png 320w',
        avif: 'static/ny25/avatarSlutskiy-184-2024-12-09-08-22-25.avif 320w',
        webp: 'static/ny25/avatarSlutskiy-184-2024-12-09-08-22-25.webp 320w',
      },
      alt: 'фото',
    },
  },
  [Ambassador.Lapenko]: {
    title: 'Для вас пожелание от Антона Лапенко',
    avatar: {
      src: {
        png: 'static/ny25/avatarLapenko-184-2024-12-09-08-26-55.png 320w',
        avif: 'static/ny25/avatarLapenko-184-2024-12-09-08-26-55.avif 320w',
        webp: 'static/ny25/avatarLapenko-184-2024-12-09-08-26-55.webp 320w',
      },
      alt: 'фото',
    },
  },
  [Ambassador.Kuruch]: {
    title: 'Для вас пожелание от Ильи Куруча',
    avatar: {
      src: {
        png: 'static/ny25/avatarKuruch-184-2024-12-09-08-28-10.png 320w',
        avif: 'static/ny25/avatarKuruch-184-2024-12-09-08-28-10.avif 854w',
        webp: 'static/ny25/avatarKuruch-184-2024-12-09-08-28-10.webp 320w',
      },
      alt: 'фото',
    },
  },
  [Ambassador.Academeg]: {
    title: 'Для вас пожелание от Academeg',
    avatar: {
      src: {
        png: 'static/ny25/avatarAcademeg-184-2024-12-09-08-25-45.png 320w',
        avif: 'static/ny25/avatarAcademeg-184-2024-12-09-08-25-45.avif 320w',
        webp: 'static/ny25/avatarAcademeg-184-2024-12-09-08-25-45.webp 320w',
      },
      alt: 'фото',
    },
  },
  [Ambassador.Ponaroshku]: {
    title: 'Для вас пожелание от Ирены Понарошку',
    avatar: {
      src: {
        png: 'static/ny25/avatarPonaroshku-184-2024-12-09-08-19-27.png 320w',
        avif: 'static/ny25/avatarPonaroshku-184-2024-12-09-08-19-27.avif 320w',
        webp: 'static/ny25/avatarPonaroshku-184-2024-12-09-08-19-27.webp 320w',
      },
      alt: 'фото',
    },
  },
  [Ambassador.Chebatkov]: {
    title: 'Для вас пожелание от Евгения Чебаткова',
    avatar: {
      src: {
        png: 'static/ny25/avatarChebatkov-184-2024-12-09-08-23-48.png 320w',
        avif: 'static/ny25/avatarChebatkov-184-2024-12-09-08-23-48.avif 320w',
        webp: 'static/ny25/avatarChebatkov-184-2024-12-09-08-23-48.webp 320w',
      },
      alt: 'фото',
    },
  },
};
